import { Controller } from 'stimulus';


export default class extends Controller {
  static targets = ['productsSelect', 'quantitySelect', 'totalPrice', 'paymentStatus', 'amountField'];

  connect() {
    this.locale = document.documentElement.lang;
    this.currency = this.totalPriceTarget.dataset.currency;
    this.handleProductChange();
    this.handleStatusChange();
  }

  handleProductChange() {
    const option = this.productsSelectTarget.options[this.productsSelectTarget.selectedIndex];
    const priceCents = parseFloat(option.dataset.priceCents) || 0.0;
    const quantity = parseInt(this.quantitySelectTarget.value, 10) || 0;
    const price = priceCents * quantity / 100;
    this.totalPriceTarget.innerHTML = this.priceFormatter(price);
  }

  // Unpaid obligations record Total Paid = $0; the amount-paid field is only
  // meaningful when recording an immediate payment, so hide and zero it when
  // the organizer selects Unpaid.
  handleStatusChange() {
    if (!this.hasAmountFieldTarget) return;

    const unpaid = this.paymentStatusTargets.some((radio) => radio.checked && radio.value === 'unpaid');
    this.amountFieldTarget.hidden = unpaid;
    if (unpaid) {
      const hiddenInput = this.amountFieldTarget.querySelector('input[type="hidden"]');
      if (hiddenInput) hiddenInput.value = '0';
    }
  }

  priceFormatter(price) {
    return new Intl.NumberFormat(this.locale,
      { style: 'currency', currency: this.currency }
    ).format(price);
  }
}
